import { render, staticRenderFns } from "./RestaurantContract.vue?vue&type=template&id=5f5e16ac&scoped=true"
import script from "./RestaurantContract.vue?vue&type=script&lang=js"
export * from "./RestaurantContract.vue?vue&type=script&lang=js"
import style0 from "./RestaurantContract.vue?vue&type=style&index=0&id=5f5e16ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e16ac",
  null
  
)

export default component.exports